export default "__VITE_ASSET__gOzmn9EX__"